import validate from "/usr/src/app/content/n3-packages-8d641a10-01f4-4791-97ab-d07452b72d93/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-8d641a10-01f4-4791-97ab-d07452b72d93/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}